import { render } from "./FileBox.vue?vue&type=template&id=70a7c8a6&scoped=true"
import script from "./FileBox.vue?vue&type=script&lang=js"
export * from "./FileBox.vue?vue&type=script&lang=js"

import "./FileBox.vue?vue&type=style&index=0&id=70a7c8a6&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a7c8a6"]])

export default __exports__